import NavLg from './navLg/NavLg';


const MyNavbar = () => {

    return  (
        <NavLg />
    ) 
};

export default MyNavbar;
